module.exports = __webpack_public_path__ + "img/footer-logo-ug.0736df0e.png";